var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 99,
    viewBox: "0 0 177 99",
    width: 177,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 7-8 53h41m0 0 3-59m-3 59v39m-24-98-7 48h21l3-48m-3 66v32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138 7-8 53h41m0 0 3-59m-3 59v39m-24-98-7 48h21l3-48m-3 66v32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.5 3.5h46v93h-46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.5 27.5h22v45h-22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.39db59aa15cd87b330583fb9ba06a7ed.svg";
export { ForwardRef as ReactComponent };